import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/dictionary/word/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/dictionary/word/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.word.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: word => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, word });

            EditService.loadScreenView(
                word,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveWordAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_WORD_ASYNC, vo });

            EditService.saveWord(
                vo,
                response => {
                    dispatch(Actions.saveWordSuccess(response));
                },
                error => {
                    dispatch(Actions.saveWordFailure(error));
                }
            );
        };
    },

    saveWordSuccess: data => ({
        type: ActionTypes.SAVE_WORD_SUCCESS,
        parentType: ActionTypes.SAVE_WORD_ASYNC,
        data
    }),

    saveWordFailure: error => ({
        type: ActionTypes.SAVE_WORD_FAILURE,
        parentType: ActionTypes.SAVE_WORD_ASYNC,
        error
    }),

    createWord: () => ({
        type: ActionTypes.CREATE_WORD
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    word: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, word: data.word };
};


const createWordReducer = (state) => {
    return { ...state, word: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_WORD_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_WORD_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_WORD_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_WORD]: createWordReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
